import React, {useState, useRef, useEffect, Fragment} from 'react';
import VisDiv from '../frontend_components/VisDiv';
import { useStateContext } from '../../context/StateContext';
import { v4 as uuidv4 } from 'uuid';
import { keyId, addValueForDropdown, copyId, errorAlert, addNameSwal, successAlert, timePassedTranslated} from '../../lib/utils'
import { useCreateReplace } from '../../hooks/mutations';
import { useQueryClient } from '@tanstack/react-query';
import {StepByStepProgress} from './StepByStepProgress'
import {FieldDropdown, TextField, Divider, ViewLabelValueField, UserIcon} from '../../components';
import { richEditorDoc, referenceDoc } from '../gestioneDatabase/Docs';
import { useQuery } from '@tanstack/react-query';
import { clientsQuery, clientsSitesQuery } from '../../lib/data';
import { _FETCH } from '../../lib/patches'
import { ArrayOfObjects, ReferenceCheckList, ImageUploadAndCrop } from './ManagementModules';
import RichTextEditor from '../RichTextEditor';
import TrueFalseToggle from '../TrueFalseToggle';
import { UserEmailPin } from './ReportAperturaEmail';
import { Notes } from './ManagementModules';
import { useAuthContext } from '../../hooks/useAuthContext';
import { useManagementContext } from '../../context/ManagementContext';
import Swal from 'sweetalert2'
import TestButton from '../frontend_components/TestButton';
import NoAccessMessage from '../NoAccessMessage';
import validator from "validator";
import { isValid } from 'date-fns';

/**
 * UserManagement is a component that manages user data
 * #anagraficheManagement
 * @param {object} data - an object containing the user data
 * @returns {JSX.Element} - a JSX element that renders the UserManagement component
 */
const UserManagement = ({data={}}) => {


    const {usersData} = data
    const {customer, apiUrl, users, sUser } = useStateContext()
    const {newUser, setNewUser, newUserEdited, setNewUserEdited} = useManagementContext()
    const customerId = customer?._id ? customer?._id : sUser?.customer?._ref
    const fetchRoute = `${apiUrl}/calls/fetch-docs`
    const {user} = useAuthContext()

    const queryClient = useQueryClient()

    const {data: clients, isLoading: clientsDataLoading} = useQuery(['clientsUserMAnagement', customer], ()=>_FETCH({route: fetchRoute, user, query: clientsQuery(customerId)}),{
        enabled: !! customerId,
        //staleTime: 1000 * 60 * 60,
        onError:(error)=>{

        },
    }) 
    const clientIds = newUser?.assignedClients?.map?.((client)=>`"${client?._ref}"`)

    const {data: sites, isLoading: sitesDataLoading} = useQuery(['sitesUserManagement', clientIds], ()=>_FETCH({route: fetchRoute, user, query: clientsSitesQuery(clientIds)}),{
        enabled: !! clientIds?.length > 0,
        //staleTime: 1000 * 60 * 60,
        onError:(error)=>{

        },
    })

    const {mutate: updateDocument} = useCreateReplace({
        onMutate: async (newDoc) => {

            await queryClient.cancelQueries({ queryKey: ['customersUsersManagement'] })
            const previousData = queryClient.getQueryData(['customersUsersManagement'])
       
            //const doc = newDoc?.doc
            
            queryClient.setQueryData(['customersUsersManagement'], (old) =>{ 
                const doc = newDoc?.doc
                const oldData = old?.length > 0 ? old : []
                const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
                return newData
            })
            return {previousData}
        },

        onError: (err, newDoc, context) => {
            console.error('Oh no, the update failed: ', err?.message)
            // Instead of just showing an alert, throw the error so ErrorBoundary can catch it
            throw new Error("ERRORE; RICARICA LA PAGINA")
        },
            onSuccess: (data, variables) => {
                successAlert("UTENTE AGGIORNATO CON SUCCESSO")
                setNewUserEdited(false)
            }
        })

  const save = (data, bypassEdit) => {
    setNewUser(data)
     if(!bypassEdit){setNewUserEdited(true)}
    //updateDocument({doc: data})
    console.log("SAVE USER DOC:", data)
}
    const updateDatabase = async(doc) => {
           await updateDocument({doc: doc})

    }

        const resetDoc = async() => {
            if(newUserEdited){
                const result = await Swal.fire({
                    title: 'Documento Non Salvato',
                    text: 'Vuoi uscire ugualmente? i dati andranno persi.',
                    icon: 'error',
                    showCancelButton: true,
                    confirmButtonText: 'Chiudi Documento',
                    cancelButtonText: 'Annulla'
                });
            
                if (result.isConfirmed) {
                    // Fall back to mailto
                    setNewUser(undefined)
                    setNewUserEdited(false)
                }
            } else {
                setNewUser(undefined)
                setNewUserEdited(false)
            }
                  
          }
          const archive = async () => {
            const archivedDoc = {...newUser, status:"ARCHIVIATO"}
            console.log("ARCHIVIA", archivedDoc)
            // Update cache first
            await updateDocument({doc: archivedDoc});
            // Then update local state
            setNewUser(archivedDoc);
            setNewUserEdited(false)
        }
        const restore = async () => {
            const restoredDoc = {...newUser, status:"ATTIVO"}
            console.log("ATTIVA", restoredDoc)
            // Update cache first
            await updateDocument({doc: restoredDoc});
            // Then update local state
            setNewUser(restoredDoc);
            setNewUserEdited(false)
        }

    const languages= [
        {label: "ITALIANO", value: "it"},
        {label: "INGLESE", value: "en"}
    ]
    const userTypes = [
        { label: 'Unknown', value: 'Unknown' },
        { label: 'Customer', value: 'Customer' },
        { label: 'Cliente', value: 'Cliente' },
        { label: 'Tecnico',  value: 'Tecnico' },
        { label: 'Admin',  value: 'Admin' },
        //{ label: 'SuperAdmin', value: 'Super Admin' },
        //{ label: 'GodMode',   value: 'God Mode' },
        { label: 'Fornitore',   value: 'Fornitore' },
      ]
      const professionalTitles = [
        {label: "ARCHITETTO", value:"Architetto"},
        {label: "INGEGNERE", value:"Ingegnere"},
        {label: "GEOMETRA", value:"Geometra"},
        {label: "SIGNOR", value:"Signor"},
        {label: "SIGNORA", value:"Signora"}
      ]
      const incarichi = [
        {label: "SINDACO", value:"Sindaco"},
        {label: "ASSESSORE", value:"Assessore"},
        {label: "RSPP", value:"RSPP"},
        {label: "RESPONSABILE DI SETTORE", value:"Responsabile Di Settore"},
        
      ]

    // REFERENCE DATA FOR REFERENCE ARRAYS
    // if templates is in reference data it filters all the data by the present registers
    const disabledClientsIds = () => {
        const selectedSites = newUser?.assignedSites?.map?.((item)=>!Array.isArray(sites) ? undefined : sites?.find?.((x)=>x?._id == item?._ref))
        const sitesClientsIds = selectedSites?.map?.((site)=>site?.client?._ref)
        return sitesClientsIds
    } 
    const clientsReferenceData = {type: "referenceArray", hideFilter:true, data: clients, propertyName: "assignedClients", disabledIds: disabledClientsIds() }
    const sitesReferenceData = {type: "referenceArray", hideFilter:true, data: sites, propertyName: "assignedSites", }

    const progressList = [
        {description: "ANAGRAFICA", component: <UserDetails doc={newUser} setDoc={save} data={{userTypes, professionalTitles, incarichi}}/>},
        {description: "ASSEGNA CLIENTI", component: <AssignClients doc={newUser} setDoc={save} data={{referenceData: clientsReferenceData}}/>},
        {description: "ASSEGNA PLESSI", component: <AssignSites doc={newUser} setDoc={save} data={{referenceData: sitesReferenceData}}/>},
        {description: "CONTATTI", component: <UserContacts doc={newUser} setDoc={save} data={{}}/>},
        {description: "FOTO PROFILO", component: <ProfilePicture doc={newUser} setDoc={save} data={{}}/>},
        {description: "NOTE", component: <Notes doc={newUser} setDoc={save} data={{}}/>},
      ] 


      const consoleData = {referenceData: clientsReferenceData, newUser}

      if(sUser?.userType !== "God Mode" && sUser?.userType !== "Admin"){
    return <NoAccessMessage/>  
} 
 if (!customerId){return <p>Customer not found</p>}
  return (
    <div style={{overflow:"auto", height:"88vh", paddingBottom:"100px"}}>   
        <h2>GESTIONE UTENTI</h2>
        <TestButton buttonId={"wqoskqsqwoskop"} message={"USE MANAGE"} consoleData={consoleData} />
        <div style={{display: "flex", alignItems:"center"}}>
            <VisDiv style={{marginBottom:"10px", marginRight:"10px"}} rules={[newUser]}>
                <button onClick={resetDoc} className={"pdf-button"}>CHIUDI DOCUMENTO</button>
            </VisDiv>
            <VisDiv style={{marginRight:"10px", marginBottom:"10px",}}  rules={[newUser]}>
                <button type="button" disabled={!newUserEdited} style={{backgroundColor: newUserEdited ? "green" : "grey"}} className="pdf-button" onClick={()=>updateDatabase(newUser)} >
                    {"SALVA DOCUMENTO"}
                </button>
            </VisDiv>
            <VisDiv style={{marginBottom:"10px", marginRight:"10px"}}  rules={[newUser && newUser?.status !== "ARCHIVIATO"]}>
                <button type="button" style={{backgroundColor: "red"}} className="pdf-button" onClick={()=>archive()} >
                    {"ARCHIVIA"}
                </button>
            </VisDiv>
            <VisDiv style={{marginBottom:"10px", marginRight:"10px"}}  rules={[newUser?.status == "ARCHIVIATO"]}>
                <button type="button" style={{backgroundColor: "green"}} className="pdf-button" onClick={()=>restore()} >
                    {"RIPRISTINA"}
                </button>
            </VisDiv>
        </div>
        <VisDiv rules={[newUser?.email]} style={{textAlign:"center"}}>
            <h2>UTENTE: {newUser?.email}</h2>
        </VisDiv>
        <VisDiv rules={[!newUser]}>
           <AddOrEditUser updateDatabase={updateDatabase} doc={newUser} setDoc={save} data={{...data, clients}}/> 
        </VisDiv>
        <VisDiv rules={[newUser]}>
            <StepByStepProgress progressList={progressList}/>
        </VisDiv>
    </div>
  )
}

export default UserManagement

/**
 * AddOrEditUser component
 * 
 * @param {Object} props
 * @param {Object} props.doc - user data
 * @param {Function} props.updateDatabase - function to update user data
 * @param {Function} props.setDoc - function to set user data
 * @param {Object} props.data - data containing users and clients
 * 
 * This component is used to add or edit user data.
 * It displays a form with user data and allows the user to edit it.
 * When the user clicks on the "SALVA" button, the updated user data is sent to the server.
 * 
 * The component also displays a list of user logs.
 * 
 * The component is wrapped in a "div" element with the class "add-or-edit-user"
 */
export const AddOrEditUser = ({doc, updateDatabase, setDoc, data={}}) => { 

    const {customer, apiUrl} = useStateContext()
    const [email, setUserEmail] = useState("")
    const [selectedUser, setSelectedUser] = useState("")
    const {users, clients} = data 
    //console.log("usersData elkdmlkweqdm", {usersData, users})
    const fetchRoute = `${apiUrl}/calls/fetch-docs`
    const {user} = useAuthContext()
    const clientIds = selectedUser?.assignedClients?.map?.((client)=>`"${client?._ref}"`)

    const {data: sites, isLoading: sitesDataLoading} = useQuery(['sitesUserManagement', clientIds], ()=>_FETCH({route: fetchRoute, user, query: clientsSitesQuery(clientIds)}),{
        enabled: !! clientIds?.length > 0,
        //staleTime: 1000 * 60 * 60,
        onError:(error)=>{
            //console.log("clients not loaded", error)
        },
    })
    const [clientFilter, setClientFilter] = useState()
    const [filterType, setFilterType] = useState({label: "ATTIVI", value: 1})
    const filterTypes = [
        {label: "ATTIVI", value: 1},
        {label: "ARCHIVIATI", value: 2},
    ]
    //console.log("dnwkjdnejn", users)
    const usersArray = (!users || users?.error || users?.length < 1 ) ? [] : users
    const usersOptions = usersArray?.map?.((user)=>({...user, label: user?.email, value: user?.email}))
    const clientsOptions = !Array?.isArray(clients) ? [] : clients?.map?.((client)=>({...client, label: client?.label, value: client?.label}))


    const duplicateDoc = () => ({
        ...selectedUser, 
        label: email, 
        userLog:[],
        acceptedPrivacyPolicy: false,
        email: "",
        password: "",
        passwordExists: false,
        emailComms: [],
        _id: uuidv4(), 
        _key: keyId(),
    })

    const emptyDoc = () => ({
        _type: "user",
        _id: uuidv4(),
        _key: keyId(),
        firstName: "",
        passwordExixts: false,
        lastName: "",
        language: "it",
        acceptedPrivacyPolicy: false,
        passwrord: "",
        image:{},
        email: "",
        userType: "Unknown",
        professionalTitle:"",
        jobTitle:"",
        incarico:"",
        emailComms: [],
        customer: referenceDoc(customer?._id),
        assignedClients: [],
        assignedSites: [],
        emailList: [],
        phoneList: [],
        emailComms:[],
        notes: richEditorDoc(""),
        status:"ATTIVO",
    })
    const labelValueDistance = 5

    const userLogs = !Array.isArray(selectedUser?.userLog) ? [] : selectedUser?.userLog?.sort(function(a, b){return b?.date - a?.date})
    const lastLog = userLogs?.length > 0 ? userLogs[0] : {}

    const selectedUserData = [
        {label: "NOME", value: selectedUser?.firstName},
        {label: "COGNOME", value: selectedUser?.lastName},
        {label: "EMAIL", value: selectedUser?.email},
        {highlight: "amber", value: selectedUser?.notification && "RICEVE NOTIFICHE GRAVI"},
        {label: "FOTO PROFILO", value: selectedUser?.image, type:"userIcon"},
        {label: "TIPOLOGIA UTENTE", value: selectedUser?.userType},
        {label: "TITOLO PROFESSIONALE", value: selectedUser?.professionalTitle},
        {label: "INCARICO", value: selectedUser?.incarico},
        {label: "POSIZIONE", value: selectedUser?.jobTitle},
        {label: "CLIENTI ASSEGNATI", value: selectedUser?.assignedClients?.map?.((item)=> !Array.isArray(clients) ? undefined : clients?.find?.((x)=>x?._id == item?._ref)?.label)?.toString()},
        {label: "PLESSI ASSEGNATI", value: selectedUser?.assignedSites?.map?.((item)=>!Array.isArray(sites) ? undefined : sites?.find?.((x)=>x?._id == item?._ref)?.label)?.toString()},
        {label: "NOTE", value: selectedUser?.notes?.blocks?.map?.((x)=>x?.text)?.toString()},
        {label: "N LOG IN", value: userLogs?.length},
        {label: "ULTIMO LOG IN", value: lastLog?.date && timePassedTranslated(lastLog?.date)},
    ]
      const createNewEmptyDoc = () => {
              const okFn = (name) => {
                const checks = () => {
                    const emailExists = users?.some((x)=>x?.email == name )
                    if(emailExists) return false
                    return true
                }
                if(!checks()){
                    errorAlert("Utente con questa email esiste già")
                    return
                }
                const docToSave = emptyDoc()
                  setDoc({...docToSave, email: name, label: name})
                  updateDatabase({...docToSave, email: name,  label: name})
                  setUserEmail(name)
              }
              addNameSwal({docType:"EMAIL", okFn})    
      }
    
      const duplicateExistingDoc = () => {

              const okFn = (name) => {
                const checks = () => {
                    const emailExists = users?.some((x)=>x?.email == name )
                    if(emailExists) return {isValid: false, message:"Quest'email esiste già"}
                    if (!validator?.isEmail(name)) {
                    console.log("email not valid", {isValid: false, email:name, message:"Il formato dell'email non è valido", check: validator?.isEmail(email)})
                    return {isValid: false, message:"Il formato dell'email non è valido"};
                    }
                    return {isValid: true} 
                }
                if(!checks()?.isValid){
                    errorAlert(checks()?.message)
                    return
                }
                  const docToSave = duplicateDoc()
                  setDoc({...docToSave, email: name, label: name})
                  updateDatabase({...docToSave, email: name, label: name})
                  setUserEmail(name)
              }
              addNameSwal({docType:"EMAIL UTENTE", okFn})  
      }
      const editExistingDoc = () => {
          setDoc(selectedUser, true)
      }
        const filterByClient = (item) => {
        if (!clientFilter) return item
        if (!item?.assignedClients || !Array.isArray(item?.assignedClients) || item?.assignedClients?.length < 1) return item
        return item?.assignedClients?.some((x) => x?._ref == clientFilter?._id)
        }
    return (
    <div>
        <h3>SELEZIONA FILTRO:</h3>
        <FieldDropdown
            sorted={true}
            isSearchable="isSearchable"
            initialValue={filterType}
            placeHolder={"SELEZIONA FILTRO"}
            options={filterTypes}
            onChange={(value) => { 
                setFilterType(value)
            }}
        />
        <Divider />
        <FieldDropdown
            sorted={true}
            isSearchable="isSearchable"
            initialValue={clientFilter}
            placeHolder={"SELEZIONA FILTRO PER CLIENTE"}
            options={clientsOptions}
            onChange={(value) => { 
                setClientFilter(value)
            }}
        />
        <Divider />
        <FieldDropdown
            sorted={true}
            isSearchable="isSearchable"
            //initialValue={expandSupplier(supplierProduct?.supplier)}
            placeHolder={"SELEZIONA UTENTE ESISTENTE"}
            options={usersOptions
                ?.filter(filterByClient)
                ?.filter(x=>{
                    if(filterType?.label == "ATTIVI") return x?.status !== "ARCHIVIATO"
                    if(filterType?.label == "ARCHIVIATI") return x?.status == "ARCHIVIATO"
                })
            }
            onChange={(value) => { 
                setSelectedUser(value)
            }}
        />
        <div style={{display:"flex", justifyContent:"space-evenly"}}>
            <VisDiv rules={[]}>
                <button className="pdf-button" onClick={createNewEmptyDoc} >INSERISCI VUOTO</button>
            </VisDiv>
            <VisDiv rules={[selectedUser]}> 
                <button className="pdf-button" onClick={editExistingDoc} >MODIFICA UTENTE ESISTENTE</button>
            </VisDiv>
            <VisDiv rules={[selectedUser]}>
                <button className="pdf-button" onClick={duplicateExistingDoc} >DUPLICA UTENTE </button>
            </VisDiv>
        </div>
        <VisDiv rules={[selectedUser]}>
            <Divider/>
            {selectedUserData?.map?.((item,index)=>{
                if(item?.type == "userIcon" && item?.value) return(
                <div key={`usericon-${index}`}>
                    <ViewLabelValueField 
                    label={item?.label} 
                    labelValueDistance={labelValueDistance}>
                        <UserIcon otherUser={selectedUser} size={250}/>
                    </ViewLabelValueField>
                </div>
                )
                return(
                    <VisDiv key={index} rules={[item?.value]}>
                        <ViewLabelValueField 
                            label={item?.label} 
                            value={item?.value}
                            labelValueDistance={labelValueDistance}
                            highlight={item?.highlight}
                        />
                    </VisDiv>
                )
            })}
            <UserEmailPin title={"COMUNICAZIONI"} index={1} user={selectedUser}/>

        </VisDiv>
    </div>
)}

/**
 * Componente che rappresenta i dettagli di un utente, 
 * come ad esempio il suo nome, cognome, titolo professionale, incarico e tipo di utente.
 * 
 * @param {Object} doc - il documento da modificare
 * @param {Function} setDoc - la funzione per aggiornare il documento
 * @param {Object} data - i dati del contesto
 * @returns {JSX.Element} - il componente che rappresenta i dettagli di un utente
 */
export const UserDetails = ({doc, setDoc, data={}}) => {
    const {professionalTitles, userTypes, incarichi} = data
    const [detailsDoc, setDetailsDoc] = useState(doc)
    return  (  
     <div>
        <TextField 
            label={"NOME"}
            value={detailsDoc?.firstName} 
            onBlur={()=>setDoc(detailsDoc)}
            onChange={(e) => setDetailsDoc({...doc, firstName: e.target.value})} 
            //description={"Questo dato non sarà inserito nell'offerta, serve per trovare il prodotto"} 
            descriptionDivider={false}
        />
        <TextField 
            label={"COGNOME"}
            value={detailsDoc?.lastName} 
            onBlur={()=>setDoc(detailsDoc)}
            onChange={(e) => setDetailsDoc({...doc, lastName: e.target.value})} 
            //description={"Questo dato non sarà inserito nell'offerta, serve per trovare il prodotto"} 
            descriptionDivider={false}
        />
         <h4>TITOLO PROFESSIONALE:</h4>
        <FieldDropdown
            sorted={true}
            isSearchable="isSearchable"
            initialValue={{label:doc?.professionalTitle, value: doc?.professionalTitle,}}
            placeHolder={"SELEZIONA TITOLO PROFESSIONALE"}
            options={professionalTitles}
            onChange={(value) => { 
                setDoc({...doc, professionalTitle: value?.value})
            }}
        />
        <h4>INCARICO:</h4>
        <FieldDropdown
            sorted={true}
            isSearchable="isSearchable"
            initialValue={{label:doc?.incarico, value: doc?.incarico,}}
            placeHolder={"SELEZIONA INCARICO"}
            options={incarichi}
            onChange={(value) => { 
                setDoc({...doc, incarico: value?.value})
            }}
        />
       <TextField 
            label={"MANSIONE"}
            value={detailsDoc?.jobTitle} 
            onBlur={()=>setDoc(detailsDoc)}
            onChange={(e) => setDetailsDoc({...doc, jobTitle: e.target.value})} 
            description={"Questo dato non descrive la posizione specifica dell'utente"} 
            descriptionDivider={true}
        />
        <h4 style={{marginTop:"10px"}}>TIPOLOGIA UTENTE:</h4>
        <FieldDropdown
            sorted={true}
            isSearchable="isSearchable"
            initialValue={{label:doc?.userType, value: doc?.userType}}
            placeHolder={"SELEZIONA TIPOLOGIA UTENTE"}
            options={userTypes}
            onChange={(value) => { 
                setDoc({...doc, userType: value?.value})
            }}
        />
    </div>
    ) 
}
/**
 * Componente che rappresenta i contatti di un utente
 * 
 * @param {Object} doc - il documento da modificare
 * @param {Function} setDoc - la funzione per aggiornare il documento
 * @param {Object} data - i dati del contesto
 * @returns {JSX.Element} - il componente che rappresenta i contatti dell'utente
 */
export const UserContacts = ({doc, setDoc, data={}}) => {
    const [email, setEmail]= useState(doc?.email)
    const emailData = {
        //existingArray: doc?.emailList ? doc?.emailList : [], 
        arrayName:"emailList",
        buttonTitle:"AGGIUNGI EMAIL",
        objectSchema: [
            {key: "email", title:"E-Mail", type:"string", order: 1},
            {key: "description", title:"Descrizione", type: "string", order: 2},
            {key: "notification", title:"Notifica", type: "boolean", order: 3, highlight: "amber", boolValue: "RICEVE NOTIFICHE GRAVI", fieldDescription: "Selezionare questa opzione se si vuole notificare le non conformità gravi."},
        ],
        emptyObject: {    
            email: "",
            description: "",
            notification: false
        }
    }
    const phoneData = {
        arrayName:"phoneList",
        buttonTitle:"AGGIUNGI NUMERO DI TELEFONO",
        objectSchema: [
            {key: "phoneNumber", title:"E-Mail", type:"string", order: 1},
            {key: "description", title:"Descrizione", type: "string", order: 2},
        ],
        emptyObject: {    
            phoneNumber: "",
            description: "",
        }
    }

    return (
   <div>
        <TextField
            label={"EMAIL"}
            value={email} 
            onBlur={()=>setDoc({...doc, email})}
            onChange={(e) => setEmail(e.target.value)} 
            description={"Quest'indirizzo email verrà utilizzato dal cliente per fare il log in"} 
            descriptionDivider={true}
        />
        <TrueFalseToggle 
            value={doc?.notification}
            onClick={()=>setDoc({...doc, notification: !doc?.notification})}
            label={"NOTIFICHE GRAVI"} 
            description={"Selezionare questa opzione se si vuole notificare le non conformità gravi. "}
        />
        <h4 style={{marginTop:"10px"}}>EMAIL AGGIUNTIVE:</h4>
        <ArrayOfObjects
            data={emailData}
            doc={doc}
            setDoc={setDoc}
        />
                <h4 style={{marginTop:"10px"}}>TELEFONI AGGIUNTIVI:</h4>
        <ArrayOfObjects
            data={phoneData}
            doc={doc}
            setDoc={setDoc}
        />
   </div>
)
}
/**
 * Componente che rappresenta l'assegnazione di un elenco di clienti a un documento
 * 
 * @param {Object} doc - il documento da modificare
 * @param {Function} setDoc - la funzione per aggiornare il documento
 * @param {Object} data - {referenceData}
 * @returns {JSX Element} - il componente che rappresenta l'assegnazione dei clienti
 */
export const AssignClients = ({doc, setDoc, data={referenceData}}) => {
    const {referenceData} = data
    return (
    <ReferenceCheckList doc={doc} setDoc={setDoc} referenceData={referenceData}/>
)
}
/**
 * Componente che rappresenta l'assegnazione di un elenco di sitiù a un documento
 * 
 * @param {Object} doc - il documento da modificare
 * @param {Function} setDoc - la funzione per aggiornare il documento
 * @param {Object} data - {referenceData}
 * @returns {JSX Element} - il componente che rappresenta l'assegnazione dei sitiù
 */
export const AssignSites = ({doc, setDoc, data={}}) => {
    const {referenceData} = data
    return (
    <ReferenceCheckList doc={doc} setDoc={setDoc} referenceData={referenceData}/>
)}
/**
 * Componente che rappresenta l'upload di un'immagine del profilo dell'utente
 * 
 * @param {Object} doc - il documento da modificare
 * @param {Function} setDoc - la funzione per aggiornare il documento
 * @param {Object} data - i dati del contesto
 * @returns {JSX Element} - il componente che rappresenta l'upload dell'immagine del profilo
 */
export const ProfilePicture = ({doc, setDoc, data={}}) => {

    return  (
    <div>
        <ImageUploadAndCrop doc={doc} setDoc={setDoc}/>     
    </div>
    ) 
}
/* export const Notes = ({doc, setDoc, data={}}) => {
    const [value, setValue] = useState(doc)
    const saveNote = () => {
        //const newValue = {...value, details: {...data, blocks: data?.blocks?.map?.((x)=>({...x, _key: keyId()}))}}
        //console.log("EDITOR BLUR", value)
        setDoc(value)
     }
     const editorDocNote = (data) => {
        //console.log("EDITOR DOC", data)
        const newValue = {...value, notes: {...data, blocks: data?.blocks?.map?.((x)=>({...x, _key: keyId()}))}}
        setValue(newValue)

    }
    return ( 
        <div>
             <RichTextEditor onBlur={saveNote} noFocus={true} existingDoc={doc?.notes} readOnly={false} editorDoc={editorDocNote}/>
        </div>

)
} */
